import React from 'react'
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemSecondaryAction from '@material-ui/core/ListItemText';
import styled, { css } from 'styled-components';
import _ from 'lodash';
import { Divider } from '@material-ui/core';

const Container = styled.div`
    width:100%
    display:grid;
    grid-template-columns:1fr 100px;
    cursor: pointer;
`
const ProjectText = styled.div`
    font-size:14px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    cursor: pointer;
`;

const ActionCount = styled.div`
    cursor: pointer;
    textAlign:'right';
    fontSize:15;
    padding-left:20px;
    font-weight:300;
    ${props =>
        props.hasActions &&
        css`
        font-weight:500;
        `};
`;

const ListStylesTemp = {
  groupLabel: {
    fontWeight: 500,
    color: 'black',
    fontSize: 14,
    paddingBottom: 10,
    paddingLeft: 20
  },
  valueLabel: {
    fontSize: 15,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    width: '320px',
  }
};

const OptionContainerDiv =styled.div`
  background-color: white;

  :hover{
    background-color: white;
  }
`

function ActionProjectSearchListItem(props) {
    // Access the `data` passed as part of `props` (which contains the 'label' and 'options')
    const { data } = props;

    console.log('ActionProjectSearchListItem data:', data);  // Logging the data for debugging

    // Assuming data.options contains the actual projects array
    const projects = data.options;

    // let project = JSON.parse(props.children);

    // const isAssigned = _.find(project.functions,{isAssigned:true});
    // const actionsCount = project.functions.reduce( (actionsCount,aFunction) => actionsCount + aFunction.actions,0 );
  
    return (
      <OptionContainerDiv>
          {!!projects?.length &&  <div>
            <div style={ListStylesTemp.groupLabel}>
              <span>{data.label}</span>
            </div>
            <Divider />
          </div>}
          {projects?.map((projectTemp, index) => {
            let project = JSON.parse(projectTemp.label);


              // Check if `project.functions` exists and is an array
              const functions = project.functions && Array.isArray(project.functions) ? project.functions : [];

              const isAssigned = _.find(functions, { isAssigned: true });

              // Safely calculate actionsCount if functions is an array
              const actionsCount = functions.reduce(
                  (actionsCount, aFunction) => actionsCount + (aFunction.actions || 0),  // Ensuring actions is a number
                  0
              );
            return (
              <ListItem
                selected={props.isFocused}
                component="div"
                style={{
                  fontWeight: props.isSelected ? 500 : 400,
                  fontSize : 12,
                  paddingLeft: 40,
                  backgroundColor: 'white',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = '#f0f0f0'; // Change this color to the desired hover color
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = 'white'; // Reset background color when mouse leaves
                }}
                {...props.innerProps}
                onClick={() => {
                  // Pass the selected project directly to the selectOption function
                  props.selectOption(project);
              }}
              >
                {isAssigned ?  
                  <Container>    
                    <ProjectText>
                        {/* {project.name} */}
                        {project && project.preferredName ? project.preferredName : project.name}
                    </ProjectText>          
                    <ActionCount hasActions={actionsCount}>
                    {`${actionsCount} Actions`}
                    </ActionCount>
                  </Container>
                  :
                  <ProjectText>
                      {/* {project.name} */}
                      {project && project.preferredName ? project.preferredName : project.name}
                  </ProjectText>
                }
              </ListItem>
            )
        })}
      </OptionContainerDiv>
    )
}

export default ActionProjectSearchListItem
